import React, { useEffect } from "react";
import "../../styles/ProvHome.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faListCheck,
  faSquareCheck,
  faBookOpen,
  faFile,
  faFileImport,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function ONMain({ setProvince }) {
  const scrollTop = (e) => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    setProvince("ON");
  });

  return (
    <div className="home-wrapper  w-full relative">
      <div className="home-pic relative">
        <img src="../../images/txnguide-picture.png" alt="home-pic" />
        <div className="x-pic absolute bottom-0 right-0 ">
          <img src="../../images/exp-x.png" alt="x-pic" />
        </div>
      </div>
      <br />
      <div className="flex flex-wrap justify-center pt-2">
        <div className="px-2">
          <Link
            to="/ON/transaction-checklists"
            style={{ textDecoration: "none" }}
            onClick={scrollTop}
          >
            <div className="flex flex-col justify-center home-buttons ">
              <div className="flex items-center justify-center ">
                <FontAwesomeIcon
                  icon={faListCheck}
                  color="#0c0f24"
                  className="home-button"
                />
              </div>
              <div className="flex flex-col leading-none w-full justify-center items-center mt-1">
                Transaction
                <div>Checklists</div>
              </div>
            </div>
          </Link>
        </div>
        <div className="px-2">
          <Link
            to="/ON/form-320"
            style={{ textDecoration: "none" }}
            onClick={scrollTop}
          >
            <div className="flex flex-col justify-center home-buttons ">
              <div className="flex items-center justify-center ">
                <FontAwesomeIcon
                  icon={faSquareCheck}
                  color="#0c0f24"
                  className="home-button"
                />
              </div>
              <div className="flex flex-col leading-none w-full justify-center items-center mt-1.5">
                FORM 320/324
                <div>Boxes</div>
              </div>
            </div>
          </Link>
        </div>
        <div className="px-2">
          <Link
            to="/ON/common-forms"
            style={{ textDecoration: "none" }}
            onClick={scrollTop}
          >
            <div className="flex flex-col justify-center home-buttons ">
              <div className="flex items-center justify-center  ">
                <FontAwesomeIcon
                  icon={faFile}
                  color="#0c0f24"
                  className="home-button"
                />
              </div>
              <div className="flex justify-center mt-3">Common Forms</div>
            </div>
          </Link>
        </div>

        <div className="px-2">
          <Link
            to="/ON/clause-generator"
            style={{ textDecoration: "none" }}
            onClick={scrollTop}
          >
            <div className="flex flex-col justify-center home-buttons ">
              <div className="flex items-center justify-center  ">
                <FontAwesomeIcon
                  icon={faPencil}
                  color="#0c0f24"
                  className="home-button"
                />
              </div>
              <div className="flex justify-center mt-3">Clause Generator</div>
            </div>
          </Link>
        </div>

        <div className="px-2">
          <Link
            to="/ON/transaction-best-practices"
            style={{ textDecoration: "none" }}
            onClick={scrollTop}
          >
            <div className="flex flex-col justify-center home-buttons ">
              <div className="flex items-center justify-center ">
                <FontAwesomeIcon
                  icon={faBookOpen}
                  color="#0c0f24"
                  className="home-button"
                />
              </div>
              <div className="flex flex-col leading-none w-full justify-center items-center mt-1">
                Transaction
                <div>Best Practices</div>
              </div>
            </div>
          </Link>
        </div>

        <div className="px-2">
          <Link
            to="/ON/office-procedures"
            style={{ textDecoration: "none" }}
            onClick={scrollTop}
          >
            <div className="flex flex-col justify-center home-buttons ">
              <div className="flex items-center justify-center  ">
                <FontAwesomeIcon
                  icon={faFileImport}
                  color="#0c0f24"
                  className="home-button"
                />
              </div>
              <div className="flex justify-center mt-3">Office Procedures</div>
            </div>
          </Link>
        </div>
      </div>
      <div className="w-full pt-2"></div>
      <p>
        eXp Realty has compiled these checklists as general guidance on common
        residential real estate transactions and are not intended to be a
        comprehensive list. Each deal is unique, so the responsibility is on
        every eXp Realty REALTOR® to perform proper due diligence as part of
        their legal obligation to provide competent service.
      </p>
      <br />
      <p>
        OREA form revisions are made at the outset of each year, and we are
        legally required to be familiar with the contents and use the current
        forms/clauses.
      </p>
      <br />
      <p>
        We are here to help and love doing so! If you have questions or require
        assistance with any of your transactions, please feel free to reach out
        to your Managing Brokers. We look forward to assisting you so that you
        feel confident in your business and your transactions run smoothly.
      </p>
      <br /> <br />
      <div className="flex flex-col justify-center w-full pt-2">
        <h1>How to use the Transaction Guide</h1>
        <br />
        <div className="flex flex-col md:flex-row md:gap-4 w-full">
          <div className="w-full md:w-1/2 mb-4 md:mb-0 ml-4">
            <strong>Transaction Checklists</strong>
            <video
              controls
              preload="auto"
              playsInline
              poster="/images/t-guide-poster-image.png"
              className="w-full h-auto"
              style={{
                maxWidth: "90%",
                backgroundColor: "#000",
              }}
            >
              <source
                src="/videos/transaction-checklists.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="w-full md:w-1/2 ml-4">
            <strong>Additional Sections</strong>
            <video
              controls
              preload="auto"
              playsInline
              poster="/images/t-guide-poster-image.png"
              className="w-full h-auto"
              style={{
                maxWidth: "90%",
                backgroundColor: "#000",
              }}
            >
              <source src="/videos/additional-sections.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  );
}

/*

<div className="flex w-full items-center justify-center">
        <div className="ON-Notice">
          <div className="flex w-full justify-center items-center pb-5">
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              size="2xl"
              color="#cc0000"
              className="pr-5"
            />
            <strong>
              Important Notice: Interest Bearing Account starting January 1,
              2025
            </strong>
          </div>
          <p>
            All new listings & transactions where eXp is holding the deposit
            will require the mandatory, company-provided Schedule B1.
            Furthermore, any pending transactions (closing after January 1,
            2025) in which eXp is holding the deposit will need to be amended
            prior to closing.
          </p>
          <p>
            <br />
            <a
              href="https://drive.google.com/drive/folders/1X_IjZH_EskRCi0XVARdtmbydB6f6ZQkl"
              target="_blank"
              rel="noreferrer"
            >
              Click here to get our Schedule B1 or Amendment
            </a>
          </p>
        </div>
      </div>

      */
